import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration
// You'll need to replace these with your actual Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyDt-ndQCBUJmbC3kglhxFzP1BdHOOiBhio",
  authDomain: "the-five-tracker.firebaseapp.com",
  projectId: "the-five-tracker",
  storageBucket: "the-five-tracker.firebasestorage.app",
  messagingSenderId: "481174890795",
  appId: "1:481174890795:web:fed77b961c12cb00ecbd6e",
  measurementId: "G-TXJB9WWYQ7"
};

// Initialize Firebase - check if app already exists to prevent duplicate initialization
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;